import React, {
  useEffect,
  useContext,
  useRef,
  Fragment,
  useState,
} from "react";

import { AppContext } from "../context";

import {
  addImageToList,
  setLog,
  userLogs,
  patLogs,
  setKotakRecapMenuSection,
  getConstraint,
  getAspectRatioClientList,
  setGlobalImageQueue,
  getWebpImageFormat,
  getImgQualityFactor,
  getNewConfirmBtn
} from "../context/utils";

import cameraImg from "../img/camera.png";
import cameraSwipe from "../img/cameraSwipe.png";

import Rotate from "./Rotate";
import { startVideoPlayback } from "../utils_new/videoPlayback";
import SafeImage from "./SafeImage";

const screenfull = require("screenfull");

let imageCaptured = false;
let image = {};
let cameraStarted = false;
let track = null;
let imgUrl = null;
let logBugs = true;

const SelfieModule = () => {
  const {
    inspectionId,
    clientId,
    stepCovered,
    setStepCovered,
    condition,
    config,
    currentBlock,
    setCondition,
    setScreen,
    mandatory,
    setMandatory,
    isLandscape,
    setLandscape,
    isIOS,
  } = useContext(AppContext);

  const [swipeCamera, setSwipeCamera] = useState("environment");

  // refs
  const singleScreen = useRef();
  const videoRef = useRef();
  const canvasRef = useRef();
  const startBtn = useRef();
  const imgRef = useRef();
  const backRef = useRef();
  const divImgRef = useRef();
  const cardDashboardRef = useRef();

  const land = () => window.innerWidth > window.innerHeight * 1.2;

  window.onresize = () => {
    setLandscape(land());

    if (land()) {
      if (cameraStarted) {
        startCamera();
      }
    }
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  if (logBugs) {
    patLogs(`Entered to ${currentBlock.tag}`, inspectionId);

    userLogs({
      position: 8,
      last_page: `${currentBlock.tag} Module`,
      inspectionId,
    });
  }

  logBugs = false;

  // -----------------------------
  // START CAMERA
  // -----------------------------
  const startCamera = async () => {
    try {
      cameraStarted = true;

      if (imgUrl) {
        divImgRef.current.src = imgUrl;
        imgRef.current.style.display = "block";
      }

      // stop old stream
      if (videoRef.current?.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => {
          track.stop();
        });

        videoRef.current.srcObject = null;
      }

      // fresh constraints every time
      const baseConstraints = getConstraint(config, clientId);
      baseConstraints.video.facingMode = swipeCamera;

      // REMOVE ZOOM TEMPORARILY
      // zoom breaks camera switching on many devices
      if (baseConstraints.video.zoom) {
        delete baseConstraints.video.zoom;
      }
      // console.log("Camera Constraints:", baseConstraints);

      const stream = await navigator.mediaDevices.getUserMedia(baseConstraints);

      window.stream = stream;

      track = stream.getTracks()[0];

      videoRef.current.srcObject = stream;
      startVideoPlayback(videoRef.current, config);

      setTimeout(() => {
        if (startBtn.current) {
          startBtn.current.style.display = "block";
        }
      }, 500);
    } catch (err) {
      // console.log("Camera Error:", err);
    }
  };

  // -----------------------------
  // CAPTURE IMAGE
  // -----------------------------
  const captureImg = () => {
    patLogs("Image capture button clicked", inspectionId);

    const cnv = canvasRef.current;
    const vw = videoRef.current;

    cnv.width = vw.videoWidth;
    cnv.height = vw.videoHeight;

    cnv.getContext("2d").drawImage(vw, 0, 0);

    const imgData =
      getWebpImageFormat() && !isIOS
        ? cnv.toDataURL("image/webp", getImgQualityFactor())
        : cnv.toDataURL("image/jpeg");

    imgUrl = imgData;

    divImgRef.current.src = imgData;

    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";

    image = {
      name: `${currentBlock["tag"]}.jpg`,
      imgData: imgData,
      tag: currentBlock["tag"],
      web_region: null,
      angle: null,
      env: 1,
      region: region,
      videoData: null,
      dialStatus: null,
      currentBlockName: currentBlock["id"],
    };

    imgRef.current.style.display = "block";
  };

  // -----------------------------
  // RETAKE
  // -----------------------------
  const imageRetake = () => {
    setStepCovered([...stepCovered]);

    imgUrl = null;

    imgRef.current.style.display = "none";
  };

  // -----------------------------
  // NEXT
  // -----------------------------
  const imageNext = () => {
    setGlobalImageQueue(image);

    logBugs = true;

    if (imageCaptured) return;

    patLogs(
      `tick button clicked and image is sent for uploading , ${currentBlock["tag"]} module is completed`,
      inspectionId,
    );

    cameraStarted = false;

    imageCaptured = true;

    if (currentBlock["mandatory"]) {
      let temp1 = mandatory;

      temp1[currentBlock["id"]] = "completed";

      setMandatory(temp1);
    }

    let temp = condition;

    temp[currentBlock["id"]] = "completed";

    setCondition(temp);

    setKotakRecapMenuSection(currentBlock["tag"]);

    setScreen("menu");

    setLog(`${currentBlock["tag"]} was captured`);

    addImageToList(image);

    window.stream = null;

    if (track) {
      track.stop();
    }

    imgUrl = null;
  };

  // -----------------------------
  // BACK
  // -----------------------------
  const back = () => {
    logBugs = true;

    patLogs("back button clicked", inspectionId);

    window.stream = null;

    if (track) {
      track.stop();
    }

    setScreen("menu");

    cameraStarted = false;
  };

  // -----------------------------
  // CAMERA SWITCH
  // -----------------------------
  useEffect(() => {
    setLandscape(land());

    startCamera();

    imageCaptured = false;

    return () => {
      if (videoRef.current?.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => {
          track.stop();
        });

        videoRef.current.srcObject = null;
      }
    };
  }, [swipeCamera]);

  return (
    <Fragment>
      {!isLandscape ? (
        <Rotate />
      ) : (
        <div id="vin-screen" ref={singleScreen}>
          {/* CANVAS */}
          <canvas
            ref={canvasRef}
            id="ios-canvas"
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
          ></canvas>

          {/* VIDEO */}
          <video
            ref={videoRef}
            id="videoWindow"
            autoPlay
            playsInline
            muted
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
          ></video>
          {
            Object.keys(config["single-image"]).includes("selfi_inst") && config["single-image"]["selfi_inst"] &&
            < div id="display-card-dashboard" style={{ display: "flex" }} ref={cardDashboardRef}>
              <div style={{ display: "flex", alignItems: "center", "justifyContent": "space-between", width: "100%", paddingTop: "2%" }}>
                <div id="image-container" style={{ width: "unset", paddingLeft: "2%" }}>
                  <SafeImage style={{ width: "45dvw", borderRadius: "5%", height: "60dvh" }} src={config["single-image"]["selfi_inst_refImg"] ? config["single-image"]["selfi_inst_refImg"] : "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/Selfie_Guiding_Image.jpg"} />
                </div>
                <div id="dashboard-points">
                  <div style={{ display: "flex", gap: "2%" }}>
                    <div className="car-black"></div>
                    <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]["selfi_instText"]).includes("inst-One")
                      ? config["single-image"]["selfi_instText"]["inst-One"]
                      : getTranslateText("Capture a selfi with your face and the vehicle.")}</p>
                  </div>
                  <div style={{ display: "flex", gap: "2%" }}>
                    <div className="car-black"></div>
                    <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]["selfi_instText"]).includes("inst-Two")
                      ? config["single-image"]["selfi_instText"]["inst-Two"]
                      : getTranslateText("Make sure the registration plate is clearly visible in the image.")}</p>
                  </div>
                  {
                    Object.keys(config["single-image"]["selfi_instText"]).includes("inst-Three") && <div style={{ display: "flex", gap: "2%" }}>
                      <div className="car-black"></div>
                      <p style={{ margin: "0px", padding: "0px", width: "90%" }}>{Object.keys(config["single-image"]["selfi_instText"]).includes("inst-Three")
                        ? config["single-image"]["selfi_instText"]["inst-Three"]
                        : ""}</p>
                    </div>
                  }
                </div>
              </div>
              <div id="btn-container" style={{ paddingBottom: "unset" }}>
                <button
                  style={{
                    backgroundColor: config["colors"]["btn"],
                    color: "var(--btn-text, #fff)",
                    width: "20%",
                    height: "100%",
                    borderRadius: "10px",
                    border: "none",
                  }}
                  onClick={() => {
                    cardDashboardRef.current.style.display = "none";
                    startBtn.current.style.display = "block";
                  }}
                >
                  {Object.keys(config["video-page"]).includes("continueText")
                    ? config["video-page"]["continueText"]
                    : getTranslateText("Continue")}
                </button>
              </div>
            </div>
          }

          {/* CAPTURE BUTTON */}
          <div
            ref={startBtn}
            id="btn-vin-start"
            onClick={captureImg}
            style={{
              backgroundImage: `url(${cameraImg})`,
              backgroundSize: "37px 37px",
              backgroundRepeat: "no-repeat",
              objectFit: "cover",
              backgroundPosition: "center",
            }}
          ></div>

          {/* BACK BUTTON */}
          <div ref={backRef} className="back-btn">
            <i className="fas fa-arrow-left fa-2x" onClick={back}></i>
          </div>

          {/* CAMERA SWITCH */}
          {Object.keys(currentBlock).includes("swipeCamera") &&
            currentBlock["swipeCamera"] && (
              <div
                className="camera-reverse"
                onClick={() => {
                  if (startBtn.current) {
                    startBtn.current.style.display = "none";
                  }
                  setSwipeCamera((prev) => prev === "user" ? "environment" : "user");
                }}
                style={{
                  backgroundImage: `url(${cameraSwipe})`,
                  backgroundSize: "50px",
                  backgroundRepeat: "no-repeat",
                  objectFit: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
            )}

          {/* CAMERA INSTRUCTION */}
          {Object.keys(currentBlock).includes("cameraInstruction") && (
            <div className="camerInst">
              <p>{currentBlock["cameraInstruction"]}</p>
            </div>
          )}

          {/* IMAGE PREVIEW */}
          <div
            id="vin-image"
            ref={imgRef}
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  backgroundColor: "black",
                  objectFit: "contain",
                }
                : {}
            }
          >
            <img
              ref={divImgRef}
              alt="captured"
              style={
                getAspectRatioClientList(clientId, config)
                  ? {
                    objectFit: "contain",
                  }
                  : {
                    width: "100vw",
                    height: "100vh",
                  }
              }
            />

            {
              getNewConfirmBtn() ? (
                <>
                  <div style={{ position: "absolute", display: "flex", width: "100%", alignItems: "center", justifyContent: "center", alignContent: "center", top: "10%" }}>
                    <div id="modalNameCont" style={{ fontSize: "16px" }}>
                      <p id="modalNameText">{currentBlock["id"] + " (" + getTranslateText("Preview") + ")"}</p>
                    </div>
                  </div>
                  <button
                    className="new-retake-btn"
                    style={{ backgroundColor: config["colors"]["crossBtn"] ? config["colors"]["crossBtn"] : "#FF8C00" }}
                    onClick={imageRetake}
                  >
                    <i className="fas fa-undo"></i>
                    {getTranslateText("Recapture")}
                  </button>
                  <button
                    className="new-next-btn"
                    style={{ backgroundColor: config["colors"]["btn"] }}
                    onClick={imageNext}
                  >
                    <i className="fas fa-check"></i>
                    {getTranslateText("Done")}
                  </button>
                </>
              ) : (
                <>
                  {/* RETAKE */}
                  <i
                    className="fas fa-times fa-2x vin-btn-retake"
                    onClick={imageRetake}
                  ></i>

                  {/* NEXT */}
                  <i
                    className="fas fa-check fa-2x vin-btn-next"
                    onClick={imageNext}
                  ></i>
                </>
              )
            }
          </div>
        </div>
      )
      }
    </Fragment >
  );
};

export default SelfieModule;
